import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  LinearProgress,
  Box,
  Stack,
} from "@mui/material";

import MemoryIcon from "@mui/icons-material/Memory";
import StorageIcon from "@mui/icons-material/Storage";
import SpeedIcon from "@mui/icons-material/Speed";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import BugReportIcon from "@mui/icons-material/BugReport";

import { isEmpty } from "../../../../utils/validation";

const ListServer = ({ data }) => {
  console.log(data);

  return (
    <Box>
      <Grid container spacing={4}>
        {!isEmpty(data)
          ? data.map((item, index) => (
              <Grid key={index} size={{ xs: 12, sm: 6, md: 6 }}>
                <BoxServerStats
                  name={item.name}
                  icon={
                    item.name.includes("production") ? (
                      <PrecisionManufacturingIcon
                        sx={{ width: 40, height: 40 }}
                      />
                    ) : (
                      <BugReportIcon sx={{ width: 40, height: 40 }} />
                    )
                  }
                  stats={item}
                />
              </Grid>
            ))
          : null}
      </Grid>
    </Box>
  );
};

const BoxServerStats = ({ name, icon, stats }) => {
  return (
    <Box sx={{ border: "solid 1px", p: 2, borderRadius: 5 }}>
      <Stack gap={3}>
        <Stack direction="row" alignItems="center" gap={2}>
          {icon}
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            {name}
          </Typography>
        </Stack>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6, lg: 4 }}>
            <StatCard
              icon={<SpeedIcon color="primary" />}
              label="Uso CPU"
              value={`${stats?.cpu?.avgLoad * 100 ?? 0}`}
              progress={stats?.cpu?.avgLoad * 100 ?? 0}
              color="#1976d2"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6, lg: 4 }}>
            <StatCard
              icon={<MemoryIcon color="#9c27b0" />}
              label="Memoria"
              value={`${stats?.mem?.used ?? 0} GB / ${
                stats?.mem?.total ?? 0
              } GB`}
              progress={Number(stats?.mem?.percentuage ?? 0)}
              color="#9c27b0"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6, lg: 4 }}>
            <StatCard
              icon={<StorageIcon color="success" />}
              label="Disco"
              value={`${stats?.disk?.used ?? 0} GB / ${
                stats?.mem?.size ?? 0
              } GB`}
              progress={Number(stats?.disk?.percentuage ?? 0)}
              color="#4caf50"
            />
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
};

const StatCard = ({ icon, label, value, progress, color }) => (
  <Card sx={{ borderRadius: 4, p: 2 }}>
    <CardContent>
      <Box display="flex" alignItems="center" gap={1}>
        {icon}
        <Typography variant="h6">{label}</Typography>
      </Box>
      <Typography variant="body1" mt={1}>
        {value}
      </Typography>
      {typeof progress === "number" && (
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            mt: 2,
            height: 10,
            borderRadius: 5,
            backgroundColor: "#eee",
            "& .MuiLinearProgress-bar": { backgroundColor: color },
          }}
        />
      )}
    </CardContent>
  </Card>
);

export default ListServer;
